export type ChangeLogEntry = {
  date: string;
  title: string;
  changes: string[];
};

export const CHANGE_LOG_ENTRIES: ChangeLogEntry[] = [
  {
    date: '18.10.2026',
    title: 'Dokumenty obce, výběr vyúčtování a přehlednější data EG.D',
    changes: [
      'Nová evidence dokumentů celé obce přímo v energetické bilanci, včetně nahrávání, stahování a mazání příloh',
      'Energetická bilance nově zobrazuje název obce, IČO a dostupný počet obyvatel z dat ČSÚ',
      'Při hromadném importu vyúčtování lze vybrat jednotlivé části k uložení',
      'Nový sloupcový graf pro porovnání výroby a spotřeby z EG.D',
      'Spolehlivější načítání dat EG.D, jednotné barvy měření a podrobnější upozornění na potíže s aktualizací při zachování dostupných uložených dat',
      'Souhrny pod společnými grafy nově uvádějí období s nejvyšší a nejnižší hodnotou a rozlišují spotřebu, náklady a emise',
      'Přehlednější upozornění na odečty a revize v detailu objektu',
    ]
  },
  {
    date: '20.9.2026',
    title: 'Smlouvy s dodavateli a přehlednější energetická bilance',
    changes: [
      'Evidence smluv s dodavateli u odběrných míst včetně příloh, historie a doby platnosti; aktuální dodavatel se určuje podle platné smlouvy',
      'V přehledu odběrných míst nově najdete aktuální měřidlo, výrobní EAN, poznámku a zdroje dat s odhadovanou četností odečtů',
      'Možnost zvolit období přímo v grafu odběrného místa',
      'Výraznější tlačítko pro přidání nebo změnu fotografie objektu',
      'Opraveno načítání vyúčtování MND, zejména rozlišení cen vysokého a nízkého tarifu od úprav za zastropování cen elektřiny',
    ]
  },
  {
    date: '7.9.2026',
    title: 'Porovnání objektů a přehlednější práce s odečty',
    changes: [
      'Nová stránka pro porovnání dvou objektů nebo odběrných míst ve zvoleném období, včetně spotřeby, nákladů a emisí',
      'Nová role Editor spotřeb umožňuje spravovat odečty bez přístupu k vyúčtováním a dalším nastavením',
      'V detailu objektu může být najednou otevřeno jen jedno odběrné místo pro přehlednější práci s daty',
      'Rozšířená paleta barev v grafech pro lepší rozlišení většího počtu odběrných míst',
      'Jednotka tun CO₂ je nyní zobrazena jednotně ve všech přehledech',
    ]
  },
  {
    date: '1.9.2026',
    title: 'Nový vzhled, výroba elektřiny a přehlednější správa energií',
    changes: [
      'Nový vzhled aplikace se světlým a tmavým režimem',
      'Přehlednější porovnání spotřeby, nákladů a emisí za zvolené období',
      'Společné grafy odečtů více odběrných míst',
      'Import dat EDC a přehled výroby a odběru elektřiny',
      'Vystavování faktur za vyrobenou elektřinu a evidence úhrad',
      'Evidence distribuční sazby a jističe u odběrných míst',
      'Volba měrných jednotek pro další druhy energií a paliv',
      'Nastavení upozornění na odečty přímo při nahrávání spotřeby',
      'Automatický přístup uživatelů k nově přidaným objektům',
      'Nastavení e-mailových upozornění na smazání odběrného místa',
      'Oprava návaznosti spotřeby při výměně měřidel',
    ]
  },
  {
    date: '7.7.2026',
    title: 'Externí data, odečty a přehlednější práce s vyúčtováním',
    changes: [
      'Přidáno napojení na EG.D pro automatické načítání externích spotřebních dat',
      'Přidána upozornění na chybějící odečty spotřeby s možností přejít rovnou k nahrání odečtu',
      'U spotřeb je nově vidět, zda pochází z vyúčtování nebo z ručního nahrání',
      'Do vyúčtování a odběrných míst byly doplněny informace o dodavateli včetně historie dodavatelů',
      'Dashboard a grafy skupin objektů byly upraveny pro přehlednější porovnání dat',
    ]
  },
  {
    date: '24.6.2026',
    title: 'Grafy, importy a návaznost měření',
    changes: [
      'Přidány nové typy grafů v detailu objektů i jejich skupin',
      'Výrazně rozšířen hromadný import faktur včetně lepší podpory automatického zakládání odběrných míst',
      'Doplněna podpora výměny měřidel a návaznosti dat, aby spotřeby a grafy plynule pokračovaly i po změně měřidla',
      'Přidána upozornění na inspekce a revize objektů s možností jejich přehlednější správy',
      'Do detailu objektu byla přidána možnost vyplnit kartu budovy'
    ]
  },
  {
    date: '18.5.2026',
    title: 'Dashboard, měření a správa účtů',
    changes: [
      'Dashboard byl rozšířen o nové grafy a porovnání spotřeby, komodit i emisí',
      'Vylepšen vzhled dashboardu včetně ikon a přehlednosti karet',
      'Při ověření účtu administrátorem se nyní automaticky odesílá potvrzovací e-mail',
      'Vylepšené čtení dat z faktur Pražské plynárenské'
    ]
  },
  {
    date: '11.5.2026',
    title: 'Levý panel a faktury za plyn',
    changes: [
      'Levý panel je nyní možné skrýt a znovu zobrazit pomocí tlačítka v pravém horním rohu',
      'Došlo ke zlepšení čtení dat z faktur za plyn'
    ]
  },
  {
    date: '26.4.2026',
    title: 'Předplatné a platby',
    changes: [
      'Integrace předplatného do aplikace',
      'Napojení platební brány pro online platby',
      'Přidány platební routy pro správu plateb',
      'Přidán ceník tarifů'
    ]
  },
  {
    date: '12.4.2026',
    title: 'Nový dashboard a přehledy',
    changes: [
      'Nasazen nový dashboard',
      'Přidán sdílený graf podporující více vstupů',
      'Rozšířeno hromadné nahrávání více faktur najednou'
    ]
  },
  {
    date: '5.4.2026',
    title: 'Modul inspekcí',
    changes: ['Přidán nový modul inspekcí']
  },
  {
    date: '31.3.2026',
    title: 'Práce s fakturami',
    changes: ['Možnost znovu použít již zpracovanou fakturu']
  },
  {
    date: '7.3.2026',
    title: 'Správa skupin objektů',
    changes: [
      'Přidáno řazení skupin objektů',
      'Přidána možnost přidávat záznamy skupin i při editaci'
    ]
  },
  {
    date: '3.3.2026',
    title: 'Správa uživatelských účtů',
    changes: [
      'Možnost resetu e-mailu uživatele',
      'Možnost znovu odeslat ověřovací e-mail'
    ]
  },
  {
    date: '26.2.2026',
    title: 'Aktualizace systému',
    changes: [
      'Podpora seskupení objektů',
      'Možnost nastavení přístupu uživatelů na úrovni objektů',
      'Opraveny menší chyby a zlepšena stabilita aplikace.'
    ]
  },
  {
    date: '20.2.2026',
    title: 'Aktualizace systému',
    changes: ['Možnost přístupu do více obcí pod jedním účtem']
  }
];
